export default (state = {}, action) => {
    switch (action.type) {

        case 'LOGIN':
            return {
                uid: action.uid,
                email: action.email,
                displayName: action.displayName,
                photoURL: action.photoURL,
                authUID: action.authUID,
                idToken: action.idToken
            }
        case 'LOGOUT':
            return {}
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/auth.js